import React from 'react';
import EditPDFLandingPageSmallUploadPanel from './EditPDFLandingPageSmallUploadPanel';

const EditPDFLandingPageSmallUploadPanelLayout = () => (
  <div className="indexRedesign">
    <div className="container-fluid">
      <div className="row-fluid">
        <div className="span6 editor-landing">
          <div className="large-upload-panel-info-wrapper">
            <h1>Free PDF Editor</h1>
            <h2>The simple PDF editor from FormSwift</h2>
            <ul className="benifits-list unstyled">
              <li className="edit-pages-info-tag-wrapper">
                <img src="/images/edit-pages-icon.png" alt="Edit Pages Icon" />
                <div className="edit-pages-info-tag">
                  <p className="new">NEW</p>
                  <p>Add, Remove, and Reorder Pages.</p>
                </div>
              </li>
              <li className="item-1">Edit any PDF or Word Document.</li>
              <li className="item-2">E-sign with ease.</li>
              <li className="item-3">Download and print.</li>
              <li className="item-4">Share in seconds.</li>
            </ul>
            <p>No software required. Simply upload and go!</p>
          </div>
        </div>
        <EditPDFLandingPageSmallUploadPanel />
      </div>
    </div>
    <div className="row-fluid press-mentions press-mentions-editor">
      <div className="span4 basic-stats">
        <img src="/images/stats-accounts.png" alt="1.2 million accounts created" />
        <img src="/images/stats-documents.png" alt="16 million documents created" />
      </div>
      <div className="span8 tv-highlight">
        <h2>As Seen In</h2>
        <img
          src="/images/pressa-gorisontal.png"
          alt="As Seen on: Inc, TNW, The Huffington Post, ReadWrite"
        />
      </div>
    </div>
  </div>
);

export default EditPDFLandingPageSmallUploadPanelLayout;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageSmallUploadPanelLayout.jsx